export default "__VITE_ASSET__183b0ac0__"